import React, { useState, useEffect } from "react";
import axios from 'axios';
function SiteEnquiry() {
  const [searchTerm, setSearchTerm] = useState('');
  const [data, setData] = useState([]);
  const [typeFilter, setTypeFilter] = useState("Enquiry");
  const fetchEnquiry = async () => {
    try {
      const res = await axios.get("https://api.sweepydo.in/fetch-contact-us");
      setData(res.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchEnquiry();
  }, []);
  const filteredData = Array.isArray(data) ? data.filter(itm => {
    const matchSearch = Object.values(itm).some(val => String(val).toLowerCase().includes(searchTerm.toLowerCase()));
    const matchType = typeFilter ? itm.type?.toLowerCase() === typeFilter.toLowerCase() : true;
    return matchSearch && matchType;
  }) : [];
  return <div 
  className="main-page"
  >

      <p className="main-page-heading">Site Enquiries</p>


                    <div className="main-page-area">

               <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">

  {/* 🔹 LEFT → Search */}
    <input type="text" className="main-input-control col-lg-2 col-md-3" placeholder="Search name ..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />

  {/* 🔹 RIGHT → Dropdown */}
    <select className="main-input-control col-lg-2 col-md-3" value={typeFilter} onChange={e => setTypeFilter(e.target.value)} >
      <option value="Enquiry">Enquiry</option>
      <option value="Delete">Delete</option>
    </select>

</div>

            <div className='table-responsive main-page-table'>
              <table className="w-100 table text-center">


                          <thead>
                            <tr>
                                <th>SN</th>
                                  <th>NAME</th>
                                <th>EMAIL</th>
                                <th>DESCRIPTION </th>

                            </tr>
                        </thead>
                <tbody>

                           {filteredData.map((s, idx) =>
                                            <tr key={s.id}>
                                              <td>{idx + 1}</td>
                                              <td>{s.name}</td>
                                              <td>{s.email}</td>
                                              <td>{s.message}</td>
                           
                                            </tr>)}
                                                            </tbody>

                    </table>
                    </div>
            </div>
        </div>;
}
export default SiteEnquiry;
